<div class="organization-invite-shell">
  <main class="organization-invite-card">
    <div class="organization-invite-icon">
      <i :class="status_icon"></i>
    </div>

    <p class="organization-invite-eyebrow">Organisation Invitation</p>
    <h1>{{ status_title }}</h1>
    <p class="organization-invite-text">{{ status_message }}</p>

    <div v-if="!has_invite_reference" class="organization-invite-actions">
      <button class="btn btn-primary rounded text-xs px-4" type="button" @click="$router.push('/login')">
        Go to Sign In
      </button>
    </div>

    <div v-else-if="!has_responded" class="organization-invite-actions">
      <button class="btn btn-primary rounded text-xs px-4" type="button" :disabled="is_submitting || !has_invite_reference" @click="respond_to_invite('accept')">
        {{ is_submitting ? 'Submitting...' : 'Accept Invite' }}
      </button>
      <button class="btn btn-outline-secondary rounded text-xs px-4" type="button" :disabled="is_submitting || !has_invite_reference" @click="respond_to_invite('reject')">
        Reject
      </button>
    </div>

    <div v-else class="organization-invite-actions">
      <button class="btn btn-primary rounded text-xs px-4" type="button" @click="continue_after_response">
        Continue
      </button>
    </div>
  </main>
</div>
